import { ActionType } from '../../../borrowers/common/BorrowerConstants';
import { FeatureType } from '@apply/constants';

const isFeatureEnabled = (featureId, userState) => {
    if (!userState || !userState.featureList) {
        return false;
    }
    const feature = userState.featureList.find((f) => f.featureId === featureId);
    return feature?.isEnabled ?? false;
};

export const getPrincipalActions = (
    principal: {
        principalId?: number | null;
        entityId?: number | null;
        email?: string | null;
    },
    userState
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    actions.push({
        actionId: ActionType.EditPrincipal,
        principalId: principal.principalId,
        entityId: principal.entityId,
        text: 'View/Edit',
        stylingMode: 'contained',
    });

    actions.push({
        actionId: ActionType.SendPasswordResetEmail,
        principalId: principal.principalId,
        text: 'Password Reset',
        stylingMode: 'contained',
        disabled: false,
    });

    if (isFeatureEnabled(FeatureType.Experience, userState)) {
        actions.push({
            actionId: ActionType.PrincipalExperience,
            principalId: principal.principalId,
            text: 'Experience',
            stylingMode: 'contained',
            disabled: !principal.email,
        });
    }

    return actions;
};
